import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  NavigationRoutes,
  NavigationRoute,
  NavigationSliceInitialState,
  InitializeNavigationPayload,
} from './navigation.types';

const initialState: NavigationSliceInitialState = {
  routes: {
    catalogSelector: false,
    cart: false,
    editor: false,
    priceTool: false,
    projects: false,
  },
  wasEditorPopstate: false,
  configuredPathHistory: [],
  initialRoute: 'catalogSelector',
};

const navigation = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    initializeNavigation(state, { payload }: PayloadAction<InitializeNavigationPayload>) {
      const { priceTool, catalogSelector, cart, projects } = payload;

      const routes: NavigationRoutes = {
        catalogSelector: !!catalogSelector,
        cart: !!cart,
        projects: !!projects,
        priceTool: !!priceTool,
        editor: !priceTool && !catalogSelector && !cart && !projects,
      };

      // Gotta do this cast since Object.entries types the keys as strings
      const routeEntries = Object.entries(routes) as [NavigationRoute, boolean][];

      // We can be sure of a found value here & cast as such since one of the routes has to be true
      const initialRoute = routeEntries.find(([, value]) => !!value) as [NavigationRoute, boolean];

      return { ...state, routes, initialRoute: initialRoute[0] };
    },
    updateCurrentRoute(state, { payload }: PayloadAction<NavigationRoute>) {
      const update = { ...state.routes };
      const routes = Object.keys(update) as NavigationRoute[];

      routes.forEach((r) => {
        update[r] = false;
      });

      update[payload] = true;

      return { ...state, routes: update };
    },
    setWasEditorPopstate(state, { payload }: PayloadAction<boolean>) {
      return { ...state, wasEditorPopstate: payload };
    },
    addConfiguredPathHistory(state, { payload }: PayloadAction<string>) {
      const update = [...state.configuredPathHistory, payload];
      return { ...state, configuredPathHistory: update };
    },
  },
});

export default navigation;
